
import { useState, useEffect } from "react";
import { FaChevronDown, FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [atTop, setAtTop] = useState(true);
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setAtTop(window.scrollY <= 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const servicesLinks = [
    { label: "Networking AMC", to: "/services/networking-amc" },
    { label: "Computer AMC", to: "/services/computer-amc" },
    { label: "Laptop AMC", to: "/services/laptop-amc" },
    { label: "Server AMC", to: "/services/server-amc" },
    { label: "Projector AMC", to: "/services/projector-amc" },
    { label: "CCTV AMC", to: "/services/cctv-amc" },
    { label: "CCTV Installation", to: "/services/cctv-installation" },
    { label: "IT Services", to: "/services/it-services" },
  ];

  const navWrapper = atTop
    ? "mx-4 mt-4 rounded-2xl max-w-7xl"
    : "w-full rounded-none";

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 flex justify-center transition-all duration-300">
        <div
          className={`w-full ${navWrapper} transition-all duration-300`}
        >
          {/* MAIN NAV */}
          <div
            className={`flex items-center justify-between px-6 lg:px-10 py-2
            bg-blue-500 text-white transition-all duration-300
            ${atTop ? "rounded-2xl shadow-lg" : "rounded-none"}
          `}
          >
            {/* LEFT: LOGO */}
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo.png" alt="logo" className="h-16 rounded-md" />
              <span className="text-xl font-semibold tracking-wide">
                Stralia
              </span>
            </Link>

            {/* CENTER: MENU */}
            <ul className="hidden lg:flex font-semibold font-PTSerif-Regular">
              <li
                className={`px-4 xl:px-6 py-4 cursor-pointer`}
              >
                <Link to="/" className="flex items-center gap-1 hover:opacity-80">HOME</Link>
              </li>
              <li
                className={`px-4 xl:px-6 py-4 cursor-pointer`}
              >
                <Link to="/about" className="flex items-center gap-1 hover:opacity-80">ABOUT US</Link>
              </li>
              <li
                className={`relative px-4 xl:px-6 py-4 cursor-pointer flex items-center gap-2 group`}
                onMouseEnter={() => setServicesOpen(true)}
                onMouseLeave={() => setServicesOpen(false)}
              >
                <span className="flex items-center gap-2">
                  SERVICES <FaChevronDown size={12} />
                </span>
                <div
                  className={`absolute top-full left-0 bg-white/95 backdrop-blur-md shadow-lg w-64 text-black z-10 rounded-b font-PTSerif-Regular transition-all duration-200 ${
                    servicesOpen ? "block" : "hidden"
                  }`}
                >
                  {servicesLinks.map((service) => (
                    <Link
                      key={service.to}
                      to={service.to}
                      className={`block px-4 py-3 hover:bg-gray-100 font-PTSerif-Regular`}
                    >
                      {service.label}
                    </Link>
                  ))}
                </div>
              </li>
              <li
                className={`px-4 xl:px-6 py-4 cursor-pointer`}
              >
                <Link to="/contact" className="flex items-center gap-1 hover:opacity-80">CONTACT US</Link>
              </li>
            </ul>

            {/* RIGHT: CTA */}
            <div className="hidden lg:flex items-center gap-10 xl:gap-12 font-PTSerif-Regular">
              <Link
                to="/contact"
                className="bg-white hover:bg-zinc-100 text-blue-500 font-semibold px-4 xl:px-6 py-2 xl:py-3 rounded transition whitespace-nowrap font-PTSerif-Regular"
              >
                Request a Service
              </Link>
            </div>

            {/* MOBILE MENU BUTTON */}
            <button
              className="lg:hidden text-xl"
              onClick={() => setMobileNavOpen(true)}
            >
              <FaBars />
            </button>
          </div>
        </div>
      </nav>

      {/* MOBILE DRAWER */}
      {mobileNavOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/40 z-40"
            onClick={() => setMobileNavOpen(false)}
          />
          <div className="fixed left-0 top-0 w-4/5 max-w-xs h-full bg-white z-50 p-6">
            <button
              className="text-2xl mb-6"
              onClick={() => setMobileNavOpen(false)}
            >
              <FaTimes />
            </button>

            <ul className="flex flex-col gap-4 font-semibold">
              <li>
                <Link to="/" onClick={() => setMobileNavOpen(false)} className="block w-full">HOME</Link>
              </li>
              <li>
                <Link to="/about" onClick={() => setMobileNavOpen(false)} className="block w-full">ABOUT US</Link>
              </li>
              <li>
                <span className="font-bold block py-2">SERVICES</span>
                <ul className="pl-4">
                  {servicesLinks.map((service) => (
                    <li key={service.to}>
                      <Link
                        to={service.to}
                        onClick={() => setMobileNavOpen(false)}
                        className="block py-1 hover:underline"
                      >
                        {service.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li>
                <Link to="/contact" onClick={() => setMobileNavOpen(false)} className="block w-full">CONTACT US</Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="mt-4 bg-blue-500 text-white px-4 py-2 rounded block text-center"
                  onClick={() => setMobileNavOpen(false)}
                >
                  Request a Service
                </Link>
              </li>
            </ul>
          </div>
        </>
      )}
    </>
  );
}